/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface LocationUsersResponse {
  owner?: LocationUser;
  members?: LocationUser[];
  /** A list of members who have temporary access to this location (e.g. temporary building maintenance, SmartThings support staff, Partner support staff, etc.). */
  temporaryMembers?: MFULocationUser[];
  /** @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$ */
  locationId?: string;
}

export enum LocationUserType {
  MFU_LOCATION_USER = 'MFU_LOCATION_USER',
  STANDARD_LOCATION_USER = 'STANDARD_LOCATION_USER',
}

export interface LocationUser {
  type: LocationUserType;
  /**
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "e4190894-6ab2-4c80-a233-29fa9e87ae90"
   */
  uuid: string;
  /** @example "pcg38apioc" */
  samsungAccountId?: string;
  /** @example "Mickey Mouse" */
  name?: string;
}

/** A location user in an MFU Location */
export type MFULocationUser = LocationUser & {
  /**
   * Empty string, needed on the model to not break ONEAPP 2022 R3 release. Callers should use Client v6 when available if they don't rely on this field being present.
   * @example ""
   */
  display?: string;
};

/** A location user in a non-MFU Location */
export type StandardLocationUser = LocationUser & {
  /**
   * Phone number or email. If the phone number is present on the User, this will be the phone number, otherwise falls back to email.
   * @example "mickey@mouse.com"
   */
  display?: string;
  /**
   * The access type this user has to a location. One of: FULL, LIMITED, OWNER, UNKNOWN.
   * @example "FULL"
   */
  access: string;
};

/** Represents a single page of Locations available in a user account. */
export interface PagedPublicLocations {
  items?: PagedPublicLocation[];
  _links?: Links;
}

/** @example {"locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Home","usernames":["example1@example.com","example2@example.com","example3@example.com"],"countryCode":"USA","latitude":45.00708112,"longitude":-93.11223629,"regionRadius":150,"temperatureScale":"F","timeZoneId":"America/Chicago","locale":"en_US","shardId":"na01d","created":1547920800,"lastModified":1548007200,"parent":{"type":"LOCATIONGROUP","id":"6ecb6c06-7319-49b1-8ebd-f97660efdd06"}} */
export interface InternalLocation {
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId?: string;
  usernames?: string[];
  /** Set of Samsung user UUIDs for users that belong to this location. */
  userUuids?: string[];
  /**
   * A nickname given to the location (eg. Home)
   * @minLength 1
   * @maxLength 40
   */
  name: string;
  /** An ISO Alpha-3 country code.  (i.e. GBR, USA) */
  countryCode?: string;
  /**
   * The OCF Region (based on country code)
   * @minLength 2
   * @maxLength 2
   */
  ocfRegion?: string;
  /** A geographical latitude. */
  latitude?: number;
  /** A geographical longitude. */
  longitude?: number;
  /** The radius in meters around latitude and longitude which defines this location. */
  regionRadius?: number;
  /** The desired temperature scale used within location. Value can be F or C. */
  temperatureScale?: string;
  /** An ID matching the Java Time Zone ID of the location. */
  timeZoneId?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /**
   * The shard a legacy location was originally created in.
   * @example "na01d"
   */
  shardId?: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /** Additional information about the location that allows SmartThings to further define your location. */
  additionalProperties?: Record<string, string>;
  /** The parent of a Location */
  parent?: LocationParent;
  /**
   * The timestamp of when a location was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a location was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
}

/** @example {"locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Home","usernames":["example1@example.com","example2@example.com","example3@example.com"],"countryCode":"USA","latitude":45.00708112,"longitude":-93.11223629,"regionRadius":150,"temperatureScale":"F","timeZoneId":"America/Chicago","locale":"en_US","shardId":"na01d","created":1547920800,"lastModified":1548007200,"parent":{"type":"LOCATIONGROUP","id":"6ecb6c06-7319-49b1-8ebd-f97660efdd06"}} */
export interface PagedPublicLocation {
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId?: string;
  usernames?: string[];
  /** Set of Samsung user UUIDs for users that belong to this location. */
  userUuids?: string[];
  /**
   * A nickname given to the location (eg. Home)
   * @minLength 1
   * @maxLength 40
   */
  name: string;
  /** An ISO Alpha-3 country code.  (i.e. GBR, USA) */
  countryCode?: string;
  /** A geographical latitude. */
  latitude?: number;
  /** A geographical longitude. */
  longitude?: number;
  /** The radius in meters around latitude and longitude which defines this location. */
  regionRadius?: number;
  /** The desired temperature scale used within location. Value can be F or C. */
  temperatureScale?: string;
  /** An ID matching the Java Time Zone ID of the location. */
  timeZoneId?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /**
   * The shard a legacy location was originally created in.
   * @example "na01d"
   */
  shardId?: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /** Additional information about the location that allows SmartThings to further define your location. */
  additionalProperties?: Record<string, string>;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:locations - the user can change the name of the location
   *   <li> d:locations - the user can delete the location
   *   <li> w:grants:locationshare - the user can share the location with other users
   *   <li> w:devices - the user can create devices on the location
   *   <li> w:locations:geo - the user can edit the geo-coordinates of the location
   *   <li> r:installedapps - the user can view or list installed apps on the location
   *   <li> w:installedapps - the user can create installed apps on the location
   *   <li> r:modes - the user can view or list modes on the location
   *   <li> r:rooms - the user can view or list rooms on the location
   *   <li> w:rooms - the user can create rooms on the location
   *   <li> r:locations:currentmode - the user can view the current mode on the location
   *   <li> w:locations:currentmode - the user can change the current mode on the location
   *   <li> r:scenes - the user can view or list scenes on the location
   *   <li> w:scenes - the user can create scenes on the location
   *   <li> r:rules - the user can view or list rules on the location
   *   <li> w:rules - the user can create rules on the location
   *   <li> r:linkedplaces - the user can view or list linked places on the location
   *   <li> w:linkedplaces - the user can create linked places on the location
   *   </ul>
   */
  allowed?: string[];
  /** The parent of a Location */
  parent?: LocationParent;
  /**
   * The timestamp of when a location was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a location was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
}

/** The parent of a Location */
export interface LocationParent {
  /** The type of the Location's parent. */
  type?: LocationParentTypes;
  /**
   * The ID of the parent
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @minLength 36
   * @maxLength 36
   */
  id?: string;
}

/**
 * The type of the Location's parent.
 * @minLength 7
 * @maxLength 14
 */
export enum LocationParentTypes {
  LOCATIONGROUP = 'LOCATIONGROUP',
  ACCOUNT = 'ACCOUNT',
}

export interface LocationUserAccessChangeRequest {
  /**
   * The access type this user has to a location. One of: full, limited. If not provided will not alter the user's grants.
   * @example "full"
   */
  access?: string;
}

export interface Modes {
  /** @maxItems 10 */
  items?: ModeWithLocationId[];
}

export interface ModeWithLocationId {
  /**
   * The ID of the Location this mode corresponds to.
   * @format uuid
   */
  locationId?: string;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:modes - the user can edit the Mode
   *   <li> d:modes - the user can delete the Mode
   *   </ul>
   */
  allowed?: string[];
  /**
   * Globally unique id for the Mode.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "9206ea57-2e2e-414c-a792-9087117ca3d8"
   */
  id?: string;
  /**
   * A user-readable label used to identify the mode in the app.
   * If the user has not set a label and the name of the mode is one of "Home", "Away", or "Night",
   * then the returned label will be translated from the name based on the `Accept-Language` header.
   * If the user has not set a label and the name of the mode is anything else, then the label will be the same as the name.
   * Unique per Location.
   * @minLength 1
   * @maxLength 25
   * @example "Vacation"
   */
  label?: string;
  /**
   * An internal name for the Mode.
   * Unique per Location.
   * @format ^[a-zA-Z0-9.-_]+$
   * @example "Home"
   */
  name?: string;
}

/** Represents a single page of Rooms available in a Location. */
export interface PagedRooms {
  items?: {
    /**
     * List of client-facing action identifiers that are currently permitted for the user.
     * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
     * If the value of this property is null (or absent), then no permission-related information is being provided.
     *   <ul>
     *   <li> d:rooms - the user can delete the room
     *   <li> w:rooms - the user can edit the room
     *   </ul>
     */
    allowed?: string[];
    /**
     * The ID of the room.
     * @format uuid
     */
    roomId: string;
    /**
     * The ID of the parent Location.
     * @format uuid
     */
    locationId: string;
    /** A name for the room (e.g. Living Room) */
    name: string;
    /**
     * Not currently in use.
     * @example null
     */
    backgroundImage?: string;
    /**
     * The timestamp of when a room was created in UTC.
     * @format date-time
     */
    created?: string;
    /**
     * The timestamp of when a room was last updated in UTC.
     * @format date-time
     */
    lastModified?: string;
    /** Data used for indoor map */
    indoorMap?: {
      /**
       * The reference id for the room map
       * @minLength 1
       * @maxLength 40
       */
      mapRoomId?: string;
      /**
       * Map Room Color
       * @minLength 1
       * @maxLength 255
       */
      color?: string;
    };
  }[];
  _links?: Links;
}

/** Represents a list of Geoplaces available for a specific owner */
export interface Geoplaces {
  items: Geoplace[];
}

/** @example {"geoplaceId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","ownerType":"LOCATION","ownerId":"9a437e5e-23c2-47ee-a915-056cf6f989b4","name":"Work","latitude":45.00708112,"longitude":-73.11223629,"regionRadius":250} */
export interface Geoplace {
  /**
   * The ID of the geoplace
   * @format uuid
   */
  geoplaceId: string;
  /** The type of owner that the Geoplace is associated to, including user permissioning. */
  ownerType: OwnerType;
  /** Global idenfifier for the given `ownerType` */
  ownerId: OwnerId;
  /** A nickname given for the Geoplace */
  name: Name;
  /** A geographical latitude */
  latitude: Latitude;
  /** A geographical longitude */
  longitude: Longitude;
  /** The radius in meters around latitude and longitude which defines this geoplace */
  regionRadius: RegionRadius;
  /**
   * A list of action that are currently permitted for the user.
   * If the value of this property is not null, then any documented action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> d:linkedplaces - the user can delete this linked place
   *   <li> w:linkedplaces - the user can edit the name of this linked place
   *   <li> w:linkedplaces:geo - the user can edit the geo-coordinates of this linked place
   *   </ul>
   */
  allowed?: string[];
}

/**
 * The type of owner that the Geoplace is associated to, including user permissioning.
 * @default "LOCATION"
 */
export enum OwnerType {
  LOCATION = 'LOCATION',
}

/**
 * Global idenfifier for the given `ownerType`
 * @format uuid
 */
export type OwnerId = string;

/**
 * A nickname given for the Geoplace
 * @minLength 1
 * @maxLength 40
 * @example "Work"
 */
export type Name = string;

/**
 * A geographical latitude
 * @min -90
 * @exclusiveMin true
 * @max 90
 * @exclusiveMax true
 */
export type Latitude = number;

/**
 * A geographical longitude
 * @min -180
 * @exclusiveMin true
 * @max 180
 * @exclusiveMax true
 */
export type Longitude = number;

/**
 * The radius in meters around latitude and longitude which defines this geoplace
 * @format int32
 * @min 250
 * @max 30000
 */
export type RegionRadius = number;

export interface Link {
  /**
   * An absolute URL linking to a resource.
   * @example "https://..."
   */
  href?: string;
}

export interface Links {
  next?: Link;
  previous?: Link;
}

export interface ErrorResponse {
  /**
   * A correlation id used for reference when contacting support.
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  requestId?: string;
  /** Details about the error. */
  error?: Error;
}

/** Details about the error. */
export interface Error {
  /**
   * Machine-readable error code.
   * @example "ConstraintViolationError"
   */
  code?: string;
  /**
   * Human-readable error message.
   * @example "The request was malformed."
   */
  message?: string;
  /**
   * Optional field used to point to a problematic part of the request.
   * @example "31192dc9-eb45-4d90-b606-21e9b66d8c2b"
   */
  target?: string;
  details?: Error[];
}

/** A paginated array of Devices. */
export interface PagedDevices {
  items?: Device[];
  _links?: Links;
}

export interface UpdateDeviceComponent {
  /** @example "main" */
  id: string;
  /**
   * The label for the device component.
   * @minLength 1
   * @maxLength 255
   * @example "Living room light switch 2"
   */
  label?: string;
  /**
   * Identifier allowing the user to pick a custom icon for the device component.
   * The icon of the main component represents the device itself
   * @minLength 1
   * @maxLength 255
   */
  icon?: string;
  /**
   * A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories). Allows the user to redefine the category of the device from what the manufacturer set by default.
   * @maxItems 1
   * @minItems 1
   */
  categories: string[];
}

export interface SharedLocation {
  /** @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc" */
  locationId?: string;
}

export interface DeviceComponent {
  /**
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   * @example "main"
   */
  id: string;
  /** UTF-8 label for the component. */
  label?: string;
  capabilities: DeviceCapabilityReference[];
  /** Defines the categories for the device. There can be up to 2, one defined by the manufacturer the other is a user selected value. */
  categories: DeviceCategory[];
  /** A typed model which describes a restriction pertaining to a platform entity. */
  restrictions?: Restriction;
  /** For internal use only */
  icon?: string;
}

export type CapabilityReference = CapabilityReferenceRequest & {
  /** @example false */
  ephemeral?: boolean;
};

export type DeviceCapabilityReference = CapabilityReference & {
  /** A map of Attribute name to Attribute state. */
  status?: CapabilityStatus;
};

/** A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories). */
export interface DeviceCategory {
  /** @example "Light" */
  name: string;
  /** @default "manufacturer" */
  categoryType: 'manufacturer' | 'user';
}

/**
 * A map of Attribute name to Attribute state.
 * @example {"switch":{"value":"on"}}
 */
export type CapabilityStatus = Record<string, AttributeState>;

export interface AttributeState {
  /** @example 0 */
  value?: object;
  /** @example "°C" */
  unit?: string;
  /** @example {"method":"manual","codeId":1234,"timeout":"2018-05-09T23:03:31+0000"} */
  data?: Record<string, object>;
  /**
   * Will always be 0 timezone offset
   * @format date-time
   * @example "2017-12-18T22:14:52.714Z"
   */
  timestamp?: string;
}

export interface IdLessHealthState {
  /** Current state of the device */
  state?: 'ONLINE' | 'OFFLINE';
  /**
   * Last reported date/time in UTC
   * @format date-time
   */
  lastUpdatedDate?: string;
}

export interface ChildDeviceRef {
  /** @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc" */
  id?: string;
}

export interface DeviceProfileReference {
  /**
   * The device profile Id
   * @example "a7b3c264-2d22-416e-bca1-ca4b59a60aee"
   */
  id?: string;
}

export interface AppDeviceDetails {
  /**
   * The ID of the installed app that integrates this device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  installedAppId?: string;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  profile?: DeviceProfileReference;
}

export type BleDeviceDetails = object;

export interface BleD2DDeviceDetails {
  /**
   * Security encryption key.
   * @example "96012869B606355A1F843B1E19DC31B1"
   */
  encryptionKey?: string;
  /**
   * Key for the decrypt.
   * @example "BMO_256-CBS-PKMS1Padding"
   */
  cipher?: string;
  /**
   * BLE Advertising Id.
   * @example "9C0D4219"
   */
  advertisingId?: string;
  /**
   * Unique device identifier.
   * @example "88-57-1d-0e-53-ab"
   */
  identifier?: string;
  configurationVersion?: string;
  /** @example "https://apisa.samsungiots.com/v1/miniature/profile/e524ceba-93b9-499d-a90a-24214f7f01cb" */
  configurationUrl?: string;
  metadata?: object;
}

export interface DthDeviceDetails {
  /** True if the device setup has been completed so the device is ready to use. */
  completedSetup: boolean;
  /** The device network type. */
  deviceNetworkType?: DeviceNetworkType;
  /**
   * The identifier for the device's DeviceType.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  deviceTypeId: string;
  /**
   * The name for the device's DeviceType.
   * @example "x.com.samsung.da.fridge"
   */
  deviceTypeName: string;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /**
   * The ID of the installed groovy application
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "8f5ra619-4c05-4a90-a245-cc129b0a8098"
   */
  installedGroovyAppId?: string;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /**
   * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
   * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
   * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
   */
  networkSecurityLevel?: DeviceNetworkSecurityLevel;
}

/**
 * The device network type.
 * @example "ZIGBEE"
 */
export type DeviceNetworkType = string;

/** True if the device is executing locally on the hub */
export type ExecutingLocally = boolean;

/**
 * The hub that the device is connected to.
 * @example "f7239728-edb3-48e9-b588-a27f30b968a0"
 */
export type HubId = string;

/**
 * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
 * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
 * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
 * @default "UNKNOWN"
 */
export enum DeviceNetworkSecurityLevel {
  UNKNOWN = 'UNKNOWN',
  ZWAVE_LEGACY_NON_SECURE = 'ZWAVE_LEGACY_NON_SECURE',
  ZWAVES0LEGACY = 'ZWAVE_S0_LEGACY',
  ZWAVES0FALLBACK = 'ZWAVE_S0_FALLBACK',
  ZWAVES2UNAUTHENTICATED = 'ZWAVE_S2_UNAUTHENTICATED',
  ZWAVES2AUTHENTICATED = 'ZWAVE_S2_AUTHENTICATED',
  ZWAVES2ACCESSCONTROL = 'ZWAVE_S2_ACCESS_CONTROL',
  ZWAVES2FAILED = 'ZWAVE_S2_FAILED',
  ZWAVES0FAILED = 'ZWAVE_S0_FAILED',
  ZWAVES2DOWNGRADE = 'ZWAVE_S2_DOWNGRADE',
  ZWAVES0DOWNGRADE = 'ZWAVE_S0_DOWNGRADE',
}

/**
 * Describes state of Zigbee OTA.
 * @default "DISABLED"
 */
export enum ZigbeeOta {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  ENABLED_WITH_LIGHTS = 'ENABLED_WITH_LIGHTS',
}

/** Device Profile information for Lan devices. This field will be empty if device type is not LAN. */
export interface LanDeviceDetails {
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
}

/** The network-specific identifier of the device on the network */
export type DeviceNetworkId = string;

/**
 * The ID of the Sprocket driver
 * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
 * @example "9314a926-528c-403f-ae56-4b0d059381dd"
 */
export type DriverId = string;

/** The identifier assigned to this edge child device by its parent */
export type ParentAssignedChildKey = string;

/** Provisioning type for a widget device */
export enum ProvisioningState {
  PROVISIONED = 'PROVISIONED',
  TYPED = 'TYPED',
  DRIVER_SWITCH = 'DRIVER_SWITCH',
  NONFUNCTIONAL = 'NONFUNCTIONAL',
}

/** Device Profile information for Zigbee devices. This field will be empty if device type is not ZIGBEE. */
export interface ZigbeeDeviceDetails {
  /** The EUID of the Zigbee device */
  eui?: DeviceEui;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
}

/**
 * The EUID of the Zigbee device
 * @example "24FD5B000105DB96"
 */
export type DeviceEui = string;

/**
 * 16-bit manufacturer identifier assigned by the Z-Wave Specification
 * @min 0
 * @max 65535
 * @example 134
 */
export type ZWaveManufacturerId = number;

/**
 * 16-bit manufacturer defined product type
 * @min 0
 * @max 65535
 * @example 17488
 */
export type ZWaveProductType = number;

/**
 * 16-bit manufacturer defined product identifier
 * @min 0
 * @max 65535
 * @example 12336
 */
export type ZWaveProductId = number;

/** Device Profile information for Z-Wave devices. This field will be empty if device type is not ZWAVE. */
export interface ZwaveDeviceDetails {
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /**
   * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
   * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
   * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
   */
  networkSecurityLevel?: DeviceNetworkSecurityLevel;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** 16-bit manufacturer identifier assigned by the Z-Wave Specification */
  manufacturerId?: ZWaveManufacturerId;
  /** 16-bit manufacturer defined product type */
  productType?: ZWaveProductType;
  /** 16-bit manufacturer defined product identifier */
  productId?: ZWaveProductId;
}

/** Device Profile information for Matter devices. This field will be empty if the device type is not MATTER */
export interface MatterDeviceDetails {
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** Vendor-supplied unique identifier. Optional. */
  uniqueId?: string;
  /** 16-bit vendor id. Optional. */
  vendorId?: number;
  /** 16-bit product id. Optional. */
  productId?: number;
  /** Listening type for the device. Optional. */
  listeningType?: MatterListeningType;
  /** List of network interfaces. Optional. */
  supportedNetworkInterfaces?: MatterNetworkInterfaces;
  /** Hardware and Software version info for matter devices. Optional. */
  version?: MatterVersion;
  /** Available Matter endpoints */
  endpoints?: MatterEndpoints;
  /** Determines whether or not to sync the child device's driver from its parent. Default is true. */
  syncDrivers?: SyncDrivers;
}

/** Device Profile information for Edge Child devices. This field will be empty if the device type is not EDGE_CHILD */
export interface EdgeChildDeviceDetails {
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The identifier assigned to this edge child device by its parent */
  parentAssignedChildKey?: ParentAssignedChildKey;
}

/** MOBILE device information. This field will be empty if the device type is not MOBILE. */
export type MobileDeviceDetails = object;

export interface IrDeviceDetails {
  /**
   * The id of the Parent device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  parentDeviceId?: string;
  /**
   * The id of the profile that describes the device components and capabilities.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b875r-0213-6479-a0bf-da7aeec3dc0a"
   */
  profileId?: string;
  /**
   * The OCF Device Type
   * @example "oic.d.tv"
   */
  ocfDeviceType?: string;
  /**
   * The id of the ircode
   * @example "006C"
   */
  irCode?: string;
  /**
   * List of IR function codes
   * @example {"statelessPowerToggleButton.powerToggle":"power","statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback"}
   */
  functionCodes?: {
    default?: string;
    [key: string]: any;
  };
  /** list of child devices */
  childDevices?: IrDeviceDetails[];
  /**
   * Key value pairs stored in the conductor for the device.
   * UI Metadata information
   */
  metadata?: Record<string, any>;
}

export interface OcfDeviceDetails {
  /** OCF device type */
  ocfDeviceType?: string;
  /** Name of the device */
  name?: string;
  /** OCF spec version */
  specVersion?: string;
  /** OCF vertical domain spec version */
  verticalDomainSpecVersion?: string;
  /** OCF manufacturer name */
  manufacturerName?: string;
  /** OCF model number */
  modelNumber?: string;
  /** OCF platform version */
  platformVersion?: string;
  /** OCF platform OS */
  platformOS?: string;
  /** OCF platform H/W version */
  hwVersion?: string;
  /** OCF firmware version */
  firmwareVersion?: string;
  /** OCF vendor ID */
  vendorId?: string;
  /** OCF vendor resource client/server version */
  vendorResourceClientServerVersion?: string;
  /** Language code */
  locale?: string;
  /** The time when the device is signed up lastly */
  lastSignupTime?: string;
}

export interface ViperDeviceDetails {
  /** @example "1a-74" */
  uniqueIdentifier?: string;
  /** @example "TP-Link" */
  manufacturerName?: string;
  /** @example "HS101" */
  modelName?: string;
  /** @example "23.123.231" */
  swVersion?: string;
  /** @example "v1 US bulb" */
  hwVersion?: string;
  /** @example "viper_bb238c20-675a-11ed-970f-571777eb58c5" */
  endpointAppId?: string;
}

export interface GroupDeviceDetails {
  /** @example "My Group" */
  groupName?: string;
  /** The type of the device group */
  groupType?: DeviceGroupType;
  devices?: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "747d79d3-4685-4852-89b6-e2fc681a590f"
     */
    deviceId: string;
    /** Components to add to the group */
    components?: {
      /** @example "main" */
      id?: string;
      [key: string]: any;
    }[];
  }[];
}

/** An array of devices in the group */
export interface DeviceGroupDevice {
  /**
   * GUID representing the device
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "747d79d3-4685-4852-89b6-e2fc681a590f"
   */
  deviceId: string;
  /** Components to add to the group */
  components?: {
    /** @example "main" */
    id?: string;
    [key: string]: any;
  }[];
}

export interface VirtualDeviceDetails {
  /** Name of the device */
  name?: string;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  commandMappings?: CommandMappings;
}

export interface HubDriver {
  /** The version of the driver revision being returned */
  driverVersion?: string;
  /**
   * The identifier of the Sprocket driver
   * @format uuid
   * @example "9314a926-528c-403f-ae56-4b0d059381dd"
   */
  driverId: string;
  /**
   * The identifier of the Sprocket channel
   * @format uuid
   * @example "9314a926-528c-403f-ae56-4b0d059381dd"
   */
  channelId?: string;
}

/** HUB device information. This field will be empty if the device type is not HUB. */
export interface HubDeviceDetails {
  /**
   * The unique identifier for this manufactured hub.
   * @format ^[0-9A-F]{16}$
   * @example "D053A8B4F6D80001"
   */
  hubEui: string;
  /**
   * The hub's firmware version
   * @format ^[0-9]\.[0-9]\.[0-9]{3}$
   * @example ""
   */
  firmwareVersion: string;
  /** A list of drivers installed on the hub */
  hubDrivers: HubDriver[];
  hubData: {
    /**
     * Zwave static DSK for the hub.
     * @example "21720-31296-41384-03009-58023-25366-38831-43982"
     */
    zwaveStaticDsk?: string;
    /** Whether zwaveS2 is enabled for this hub. */
    zwaveS2: boolean;
    /**
     * The hardwareType for this hub
     * @example "V3_HUB"
     */
    hardwareType: string;
    /**
     * The hub's hardware ID
     * @example "00A2"
     */
    hardwareId?: string;
    /**
     * The Zigbee firmware version for this hub
     * @example "5.4.0"
     */
    zigbeeFirmware?: string;
    /** Whether the hub supports zigbee3 */
    zigbee3: boolean;
    /** Describes state of Zigbee OTA. */
    zigbeeOta?: ZigbeeOta;
    /** Indicates if Zigbee OTA is enabled. */
    otaEnable?: string;
    /** Whether the hub allows zigbee unsecure rejoin */
    zigbeeUnsecureRejoin: boolean;
    /** Possible Values for Hub Characteristic "Availability" flags */
    primarySupportAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    secondarySupportAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    zigbeeAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    zwaveAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    threadAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    lanAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    matterAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    localVirtualDeviceAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    childDeviceAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    edgeDriversAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    hubReplaceAvailability?: AvailabilityCharacteristic;
    /** The primary hub device id for this hub. Null/Empty if hub is not a repeater. */
    primaryHubDeviceId?: string;
    /** The Zigbee Channel of the Hub. */
    zigbeeChannel?: string;
    /** The Personal Area Network (PAN) id of the zigbee network the hub is on. */
    zigbeePanId?: string;
    /** The unique identifier for this manufactured hub. */
    zigbeeEui?: string;
    /** The short address of a node in Zigbee network. */
    zigbeeNodeID?: string;
    /** The address of a single node in the network */
    zwaveNodeID?: string;
    /** The common identification of all nodes belonging to one logical Z-Wave network */
    zwaveHomeID?: string;
    zwaveSucID?: string;
    zwaveVersion?: string;
    /** The global region this zwave radio is operating in. */
    zwaveRegion?: string;
    /** MAC address of the hubs network interface. */
    macAddress?: string;
    /** IP address of the hub. */
    localIP?: string;
    /** Whether the hub is zigbee radio functional. */
    zigbeeRadioFunctional?: boolean;
    /** Whether the hub is zwave radio functional. */
    zwaveRadioFunctional?: boolean;
  };
}

/**
 * Possible Values for Hub Characteristic "Availability" flags
 * @example "Available"
 */
export enum AvailabilityCharacteristic {
  Available = 'Available',
  Unavailable = 'Unavailable',
  Unsupported = 'Unsupported',
}

/**
 * The type of device integration.
 * All types besides ENDPOINT_APP will have profile populated.
 * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
 * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
 * If the type is IR, the details are in the "ir" field.
 * If the type is IR_OCF, the details are in the "irOcf" field.
 * If the type is VIPER, the details are in the "viper" field.
 */
export enum DeviceIntegrationType {
  APP = 'APP',
  BLE = 'BLE',
  BLED2D = 'BLE_D2D',
  DTH = 'DTH',
  ENDPOINT_APP = 'ENDPOINT_APP',
  GROUP = 'GROUP',
  HUB = 'HUB',
  IR = 'IR',
  IR_OCF = 'IR_OCF',
  LAN = 'LAN',
  MATTER = 'MATTER',
  MOBILE = 'MOBILE',
  MQTT = 'MQTT',
  OCF = 'OCF',
  PENGYOU = 'PENGYOU',
  SHP = 'SHP',
  VIDEO = 'VIDEO',
  VIPER = 'VIPER',
  VIRTUAL = 'VIRTUAL',
  WATCH = 'WATCH',
  ZIGBEE = 'ZIGBEE',
  ZWAVE = 'ZWAVE',
  EDGE_CHILD = 'EDGE_CHILD',
}

export interface Device {
  /**
   * The identifier for the device instance.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId: string;
  /**
   * The identifier for the owner of the device instance.
   * @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc"
   */
  ownerId?: string;
  /**
   * The name that the device integration (Device Handler or SmartApp) defines for the device.
   * @example "color.light.100x"
   */
  name?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @example "color.light.100x"
   */
  label?: string;
  /**
   * The device manufacturer code.
   * @example "010F-0B01-2002"
   */
  deviceManufacturerCode?: string;
  /**
   * The device manufacturer name.
   * @example "SmartThings"
   */
  manufacturerName: string;
  /**
   * The device model.
   * @example "FGMS-001"
   */
  deviceModel?: string;
  /**
   * An non-unique id that is used to help drive UI information.
   * @example "VD-STV_2018_K"
   */
  presentationId: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  /**
   * The ID of the Room with which the device is associated. If the device is not associated with any room, then this field will be null.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0fd2b1ef-1b33-4a54-9153-65aca91e9660"
   */
  roomId?: string;
  /** The IDs of all locations this device is shared with. */
  sharedLocations?: SharedLocation[];
  /** The IDs of all compenents on the device. */
  components?: DeviceComponent[];
  /** The time when the device was created at. */
  createTime?: string;
  healthState?: IdLessHealthState;
  /** The id of the Parent device. */
  parentDeviceId?: string;
  /** Device details for all child devices of the device. */
  childDevices?: ChildDeviceRef[];
  profile?: DeviceProfileReference;
  /** Device Profile information for a SmartApp. This field will be empty if device type is not ENDPOINT_APP. */
  app?: AppDeviceDetails;
  /** Bluetooth device information. This field will be empty if device type is not BLE. */
  ble?: BleDeviceDetails;
  /** Bluetooth device to device information. This field will be empty if device type is not BLE_D2D. */
  bleD2D?: BleD2DDeviceDetails;
  /** Device Profile information for DTH. This field will be empty if device type is not DTH. */
  dth?: DthDeviceDetails;
  /** Device Profile information for Lan devices. This field will be empty if device type is not LAN. */
  lan?: LanDeviceDetails;
  /** Device Profile information for Zigbee devices. This field will be empty if device type is not ZIGBEE. */
  zigbee?: ZigbeeDeviceDetails;
  /** Device Profile information for Z-Wave devices. This field will be empty if device type is not ZWAVE. */
  zwave?: ZwaveDeviceDetails;
  /** Device Profile information for Matter devices. This field will be empty if the device type is not MATTER */
  matter?: MatterDeviceDetails;
  /** Device Profile information for Edge Child devices. This field will be empty if the device type is not EDGE_CHILD */
  edgeChild?: EdgeChildDeviceDetails;
  /** HUB device information. This field will be empty if the device type is not HUB. */
  hub?: HubDeviceDetails;
  /** MOBILE device information. This field will be empty if the device type is not MOBILE. */
  mobile?: MobileDeviceDetails;
  /** IR device information. This field will be empty if device type is not IR. */
  ir?: IrDeviceDetails;
  /** IR_OCF device information. This field will be empty if device type is not IR_OCF. */
  irOcf?: IrDeviceDetails;
  /** OCF device information. This field will be empty if device type is not OCF. */
  ocf?: OcfDeviceDetails;
  /** Viper device information. This field will be empty if device type is not VIPER. */
  viper?: ViperDeviceDetails;
  /** Group device information. This field will be empty if device type is not GROUP. */
  group?: GroupDeviceDetails;
  /** Virtual device information. This field will be empty if device type is not VIRTUAL. */
  virtual?: VirtualDeviceDetails;
  /**
   * The type of device integration.
   * All types besides ENDPOINT_APP will have profile populated.
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  type: DeviceIntegrationType;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  /**
   * *DEPRECATED* please use `presentationId`
   * Vendor id of the device, used for UI.
   */
  vid?: string;
  /**
   * *DEPRECATED* please use `manufacturerName`
   * Manufacturer model number, used for UI.
   */
  mnmn?: string;
  /** The OCF device type (resource), used for UI. */
  ocfDeviceType?: string;
  /** Restriction tier of the device, if any. */
  restrictionTier: number;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:devices - the user can change device details
   *   <li> w:devices:locationId - the user can move the device from a location
   *   <li> w:devices:roomId - the user can move or remove the device from a room
   *   <li> x:devices - the user can execute commands on the device
   *   <li> d:devices - the user can uninstall the device
   *   </ul>
   * @uniqueItems true
   */
  allowed?: 'w:devices' | 'w:devices:locationId' | 'w:devices:roomId' | 'x:devices' | 'd:devices';
  /** The location of a device on a floorplan map, if any. */
  indoorMap?: IndoorMap;
  /** list of possible icon this particular device can have */
  possibleIcons: PossibleIcon[];
  icons: Icons;
  subgroupIcons?: SubGroupIcon[];
  badgeIcons?: BadgeIcons;
  /** the device is movable to other location */
  movable: boolean;
  /** If true the device is marked as hidden for the calling user. */
  hidden: boolean;
}

/**
 * The location of a device on a floorplan map, if any.
 * @example {"coordinates":["1.0","2.0","3.0"],"rotation":["0","0","0"],"visible":true,"data":[{"extraData1":"some data"}]}
 */
export interface IndoorMap {
  /**
   * The coordinates to be used to map the device.
   * @maxItems 3
   * @minItems 3
   */
  coordinates?: number[];
  /**
   * The rotational data for the device.
   * @maxItems 3
   * @minItems 3
   */
  rotation?: number[];
  /** Whether or not the device is visible on the map. */
  visible?: boolean;
  /** Key value pairs to place additional information. */
  data?: Record<string, any>;
}

export interface Icons {
  /** url of the colored icon */
  coloredIcon: string;
  /** url of the dimmed icon */
  dimmedIcon: string;
  /** url of the activated icon */
  activatedIcon: string;
  /** url of the inactivated icon */
  inactivatedIcon: string;
  /** url of the disconnected icon */
  disconnectedIcon: string;
  /** url of the running icon */
  runningIcon?: string;
  /** url of the quickBoard icon */
  quickBoardIcon: string;
  /** url of the animation icon */
  animationIcon?: string;
  /** url for the colored auto icon */
  coloredAutoIcon: string;
  /** url for the dimmed auto icon */
  dimmedAutoIcon: string;
  /** url for the running auto icon */
  runningAutoIcon: string;
  /** url of the disconnected auto icon */
  disconnectedAutoIcon: string;
  /** key of the current icon. Will be one of ones in possibleIcons. Can be null if possibleIcons is empty */
  iconKey?: string;
  /**
   * last time any of the icons in the object got updated
   * @format date-time
   */
  lastUpdateDate: string;
}

export interface SubGroupIcon {
  /** name of the group of icons identifying it */
  groupId: any;
  icons: Icons;
}

export interface PossibleIcon {
  /** url of the icon */
  url: string;
  /** key to send to the cloud for updated icon */
  key: string;
  /**
   * last time any of the icons in the object got updated
   * @format date-time
   */
  lastUpdateDate: string;
}

export interface IconData {
  /** key of the icon to set on the device */
  key: string;
}

export interface UpdateDeviceRequest {
  /**
   * The label for the Device.
   * @minLength 1
   * @maxLength 255
   * @example "Living room light"
   */
  label?: string;
  /**
   * The ID of the Location where the Device should be moved to.
   * Not all Devices support Location moves.
   * Moving between some Locations may be rejected depending on the data region used.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  /**
   * The ID of the Room with which to associate the Device is associated.
   * The Room must be valid for the Location of the Device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0fd2b1ef-1b33-4a54-9153-65aca91e9660"
   */
  roomId?: string;
  /** key of the icon to set on the device */
  iconKey?: string;
  /** The location of a device on a floorplan map, if any. */
  indoorMap?: IndoorMap;
}

export type BadgeIcons = BadgeIconData[];

export interface BadgeIconData {
  /** url of the colored badge icon */
  coloredIcon: string;
  /** url of the dimmed badge icon */
  dimmedIcon: string;
  /** url of the activated badge icon */
  activatedIcon: string;
  /** url of the inactivated badge icon */
  inactivatedIcon: string;
  /** url of the disconnected badge icon */
  disconnectedIcon: string;
  /** key of the current badge icon */
  iconKey: string;
  /**
   * last time any of the badge icons in the object got updated
   * @format date-time
   */
  lastUpdateDate: string;
}

/** A typed model which describes a restriction pertaining to a platform entity. */
export interface Restriction {
  /** The restriction level of an entity to limit actions it can take. */
  tier: number;
  /** The number of days to retain the state before deletion. */
  historyRetentionTTLDays?: number;
  /**
   * Indicate whether or not the entity is visible when restricted.
   * @default false
   */
  visibleWhenRestricted?: boolean;
}

/** The type of the device group */
export enum DeviceGroupType {
  LIGHTING = 'LIGHTING',
  GENERIC = 'GENERIC',
  UNDETERMINED = 'UNDETERMINED',
  VIDEO_CAMERA = 'VIDEO_CAMERA',
}

/** Request to create a virtual device. You can either specify a `deviceProfileId` or `deviceProfile` definition that will be automatically provisioned. */
export type VirtualDeviceCreateRequest = {
  owner: DeviceOwner;
  /** Device profile identifier for a virtual device. Required unless the `deviceProfile` field is populated. */
  deviceProfileId?: DeviceProfileId;
  deviceProfile?: DeviceProfile;
  /** The name of the device. */
  name: Name;
  /**
   * ID of the room to install the device into. Only applicable for `LOCATION` owned devices.
   * @format uuid
   */
  roomId?: string;
  commandMappings?: CommandMappings;
  /** The environmental context in which this device executes. */
  executionTarget?: ExecutionTarget;
  /** Identifier for the hub associated with a virtual device (only applicable for locally executing devices). */
  hubId?: HubId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** the ID of the Edge channel containing the driver ID. */
  channelId?: ChannelId;
};

export type DeviceOwner = {
  /** The type of owner the device will be installed with. Currently only `LOCATION` is available, but with the intention of supporting `USER` later on. */
  ownerType?: DeviceOwnerType;
  /** The owner ID for the device. */
  ownerId?: OwnerId;
};

export interface DeviceProfile {
  /**
   * A name for the implicit profile. Names have no uniqueness or null constraints.
   * @format ^(?!\s)[-_!.~'() *0-9a-zA-Z\p{L}]{1,100}(?<!\s)$
   * @minLength 1
   * @maxLength 100
   * @example "thermostat1.model1"
   */
  name?: string;
  /**
   * A list of components for this profile. Exactly 1 component ID must be `main`.
   * @maxItems 20
   * @minItems 1
   */
  components: DeviceComponentRequest[];
  /** Additional information about the device profile, limited to 10 entries. */
  metadata?: DeviceProfileMetadata;
  /** The restriction to limit actions a device can take. */
  restrictions?: DeviceRestriction;
  /** A list of preferences for this profile, whether implicit or explicit. */
  preferences?: PreferenceRequest[];
  config?: DeviceProfileConfig;
}

export interface CommandMappings {
  commands?: CommandMapping[];
}

/**
 * A mapping of `commandName` to `attribute.value` that will allow users to support complex commands that would otherwise
 * not be determinable simply by the capabililty contract.
 */
export interface CommandMapping {
  /** The Capability ID. */
  capabilityId: string;
  /** The Capability version number. */
  version: number;
  /** The command name to apply the mapping to on the device */
  command: string;
  /** A collection of attribute values, replicator will use these to create device events in serial for the specified command. */
  eventValues: AttributeValue[];
}

export interface DeviceComponentRequest {
  /** UTF-8 label for the component. */
  label?: string;
  /**
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   * @example "main"
   */
  id: string;
  /**
   * A list of `[ 1..20 ]` capabilities for this component.
   * @maxItems 20
   * @minItems 1
   */
  capabilities: CapabilityReferenceRequest[];
  categories: DeviceCategory[];
  /** A typed model which describes a restriction pertaining to a platform entity. */
  restrictions?: Restriction;
}

/**
 * Additional information about the device profile, limited to 10 entries.
 * @example {"firmWareVersion":"0.2.123","manufacturerName":"SmartThingsCommunity"}
 */
export type DeviceProfileMetadata = any;

/** The restriction to limit actions a device can take. */
export type DeviceRestriction = Restriction;

/** @example {"title":"Temperature Offset","description":"The offset for a particular temperature setting","required":false,"preferenceType":"number","definition":{"minimum":-10,"maximum":10,"default":0}} */
export interface PreferenceRequest {
  /** The ID of the preference */
  preferenceId?: string;
  /**
   * An alphanumeric English language name for this preference. Will be appended to a namespace to generate the full preference id.
   * @pattern ^[a-zA-Z0-9][a-zA-Z0-9 ]{1,35}$
   * @example "tempOffset"
   */
  name: string;
  /**
   * A short description for this preference.
   * @example "Temperature Offset"
   */
  title: string;
  /**
   * A long description for this preference.
   * @example "The offset for a particular temperature setting"
   */
  description?: string;
  /**
   * A flag describing whether this preference is explicit, or inline.
   * @default false
   */
  explicit?: boolean;
  /**
   * A flag describing whether this property is required or not.
   * @default false
   */
  required?: boolean;
  /** The type of preference this is. */
  preferenceType: PreferenceType;
  /** The definition of this preference. */
  definition: {
    /**
     * Minimum value a preference may be set to. Only valid for `integer` and `number` preference types.
     * @format double
     */
    minimum?: number;
    /**
     * Maximum value a preference may be set to. Only valid for `integer` and `number` preference types.
     * @format double
     */
    maximum?: number;
    /** Minimum length a string may be set to. Only valid for `string` preference type. */
    minLength?: number;
    /** Maximum length a string may be set to. Only valid for `string` preference type. */
    maxLength?: number;
    /** Default value for a preference. */
    default?: any;
    /** The type of a string preference. `text` is a normal preference, `password` encrypts the values, and `paragraph` is for documentation purposes. */
    stringType?: 'text' | 'password' | 'paragraph';
    /** The available selections for an `enumeration` preference. */
    options?: Record<string, string>;
  };
}

/** The description of an attribute value that will be used to populate an event. */
export interface AttributeValue {
  /** The attribute that this command will correspond to */
  attribute?: string;
  /** How will the attribute be provided? Choose either to provide it with a command at runtime or to provide a set value here. */
  inputType?: 'STATIC' | 'ARGUMENT';
  /** The argument to be used automatically for this command mapping. Any simple type is accepted. */
  staticValue?: object;
}

export type CapabilityReferenceRequest = BaseCapabilityReference & {
  config?: CapabilityConfiguration;
  /** A typed model which describes a restriction pertaining to a platform entity. */
  restrictions?: Restriction;
};

export interface CapabilityConfiguration {
  values: CapabilityConfigurationValue[];
}

export interface CapabilityConfigurationValue {
  /**
   * The path to the preference attribute that is being configured.
   * @example "thermostatMode.value"
   */
  key: string;
  /**
   * The range of values supported by the capability attribute. The range must be a subset of the one defined on the capability. Either `range` OR `enabledValues` must be provided, not both.
   * @maxItems 2
   * @minItems 2
   * @example "[1, 50]"
   */
  range?: number[];
  /**
   * The list of enumerated values that are supported for the capability attribute. The list of supported value must be a subset of the one defined on the capability. Either `range` OR `enabledValues` must be provided, not both.
   * @example "[ "cooling", "fan only", "heating", "idle" ]"
   */
  enabledValues?: string[];
  /**
   * The incremental step that increases or decreases for numeric values.
   * @format double
   * @default 1
   */
  step?: number;
}

export interface DeviceProfileConfig {
  /** Provides custom configuration for the automation view associated with the implicitly generated device configuration. */
  automation?: AutomationConfiguration;
}

/** Provides custom configuration for the automation view associated with the implicitly generated device configuration. */
export interface AutomationConfiguration {
  /** Provides custom configuration for each automation action item. */
  actions?: AutomationActionItemConfiguration[];
}

/** Provides custom configuration for an automation action item. For example, this configuration may be used exclude specific capabilities from an automation action item. */
export interface AutomationActionItemConfiguration {
  /** ID of the capability associated with the action */
  capability: string;
  config: {
    exclusion?: {
      exclude?: ExcludedActionItem[];
    };
  };
}

export interface ExcludedActionItem {
  /** @example "pictureMode" */
  capability?: string;
}

/** The type of preference this is. */
export enum PreferenceType {
  Integer = 'integer',
  Number = 'number',
  Boolean = 'boolean',
  String = 'string',
  Enumeration = 'enumeration',
}

export interface BaseCapabilityReference {
  /** @example "switch" */
  id: string;
  /** @example 1 */
  version?: number;
}

/**
 * Device profile identifier for a virtual device. Required unless the `deviceProfile` field is populated.
 * @format uuid
 */
export type DeviceProfileId = string;

/**
 * The name of the device.
 * @example "Virtual Switch"
 */

// removed this line because it is a duplicate definition
// export type Name = string;

/** The owner ID for the device. */

// removed this line because it is a duplicate definition
// export type OwnerId = string;

/**
 * The type of owner the device will be installed with. Currently only `LOCATION` is available, but with the intention of supporting `USER` later on.
 * @example "LOCATION"
 */
export enum DeviceOwnerType {
  LOCATION = 'LOCATION',
}

/**
 * Identifier for the hub associated with a virtual device (only applicable for locally executing devices).
 * @format uuid
 */

// removed this line because it is a duplicate definition
// export type HubId = string;

/**
 * the ID of the Edge channel containing the driver ID.
 * @format uuid
 */
export type ChannelId = string;

/**
 * The environmental context in which this device executes.
 * @default "CLOUD"
 * @example "CLOUD"
 */
export enum ExecutionTarget {
  CLOUD = 'CLOUD',
  LOCAL = 'LOCAL',
}

/** Request to create a virtual device from a prototype. */
export type VirtualDeviceFromPrototypeRequest = {
  /** The name of the device. */
  name: Name;
  /**
   * The prototype type, or template, that will determine the kind of device created.
   * @example "VIRTUAL_SWITCH"
   */
  prototype:
    | 'VIRTUAL_BUTTON'
    | 'VIRTUAL_CAMERA'
    | 'VIRTUAL_COLOR_BULB'
    | 'VIRTUAL_CONTACT_SENSOR'
    | 'VIRTUAL_DIMMER'
    | 'VIRTUAL_DIMMER_SWITCH'
    | 'VIRTUAL_GARAGE_DOOR_OPENER'
    | 'VIRTUAL_HUMIDITY_SENSOR'
    | 'VIRTUAL_LOCK'
    | 'VIRTUAL_METERED_SWITCH'
    | 'VIRTUAL_MOTION_SENSOR'
    | 'VIRTUAL_MULTI_SENSOR'
    | 'VIRTUAL_PRESENCE_SENSOR'
    | 'VIRTUAL_REFRIGERATOR'
    | 'VIRTUAL_REMOTE'
    | 'VIRTUAL_RGBW_BULB'
    | 'VIRTUAL_SIREN'
    | 'VIRTUAL_SMOKE_DETECTOR'
    | 'VIRTUAL_SWITCH'
    | 'VIRTUAL_TEMPERATURE_SENSOR'
    | 'VIRTUAL_THERMOSTAT'
    | 'VIRTUAL_WATER_SENSOR'
    | 'VIRTUAL_WATER_VALVE'
    | 'VIRTUAL_WHITE_BULB'
    | 'VIRTUAL_WINDOW_TREATMENT';
  owner: DeviceOwner;
  /**
   * ID of the room to install the device into. Only applicable for `LOCATION` owned devices.
   * @format uuid
   */
  roomId?: string;
  /** The environmental context in which this device executes. */
  executionTarget?: ExecutionTarget;
  /** Identifier for the hub associated with a virtual device (only applicable for locally executing devices). */
  hubId?: HubId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** the ID of the Edge channel containing the driver ID. */
  channelId?: ChannelId;
};

/** Listening type for the device. Optional. */
export enum MatterListeningType {
  ALWAYS = 'ALWAYS',
  SLEEPY = 'SLEEPY',
}

/** Hardware and Software version info for matter devices. Optional. */
export interface MatterVersion {
  /**
   * 16-bit hardware version. Optional.
   * @min 0
   * @max 65535
   * @example 771
   */
  hardware?: number;
  /** Label for the hardware version. Optional. */
  hardwareLabel?: string;
  /**
   * 32-bit software version. Optional.
   * @min 0
   * @max 4294967295
   * @example 50529027
   */
  software?: number;
  /** Label for the hardware version. Optional. */
  softwareLabel?: string;
}

/** List of network interfaces. Optional. */
export type MatterNetworkInterfaces = MatterNetworkInterface[];

/** Supported Network Interfaces of the Device */
export enum MatterNetworkInterface {
  THREAD = 'THREAD',
  WIFI = 'WIFI',
  ETHERNET = 'ETHERNET',
}

/** Available Matter endpoints */
export type MatterEndpoints = MatterEndpoint[];

/** Matter device endpoint */
export interface MatterEndpoint {
  /**
   * 16-bit identifier for the endpoint
   * @min 0
   * @max 65535
   * @example 771
   */
  endpointId?: number;
  /** List of device types for the endpoint */
  deviceTypes?: MatterEndpointDeviceType[];
}

/** Device type for a matter endpoint */
export interface MatterEndpointDeviceType {
  /**
   * 32-bit identifier for the device type
   * @min 0
   * @max 4294967295
   * @example 197379
   */
  deviceTypeId?: number;
}

/**
 * Determines whether or not to sync the child device's driver from its parent. Default is true.
 * @example true
 */
export type SyncDrivers = boolean;

export interface ListLocationsParams {
  /**
   * Determines whether the response should include data from MFU locations. Note that locations owned by MFU properties who are on the allow list will not be filtered out, regardless of the value of this param.
   * @default false
   */
  includeMfuLocations?: boolean;
  /** If set to true, the response may contain the allowed list property */
  allowed?: boolean;
}

export interface GetLocationParams {
  /** If set to true, the response may contain the allowed list property */
  allowed?: boolean;
  /**
   * The ID of the Location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetLocationUsersParams {
  /**
   * Determines whether the response should include data from MFU locations. Note that locations owned by MFU properties who are on the allow list will not be filtered out, regardless of the value of this param.
   * @default false
   */
  includeMfuLocations?: boolean;
  /**
   * The ID of the Location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetAllLocationUsersParams {
  /**
   * Determines whether the response should include data from MFU locations. Note that locations owned by MFU properties who are on the allow list will not be filtered out, regardless of the value of this param.
   * @default false
   */
  includeMfuLocations?: boolean;
}

export interface GetAllModesParams {
  /** If set to true, the response may contain the allowed list property */
  allowed?: boolean;
}

export interface GetAllCurrentModesParams {
  /** If set to true, the response may contain the allowed list property */
  allowed?: boolean;
}

export interface ListGeoplacesParams {
  /**
   * The type of owner that the Geoplace is associated to, including user permissioning. If present, `ownerId` must also be present.
   * @default "LOCATION"
   */
  ownerType?: 'LOCATION';
  /**
   * Global identifier for the given `ownerType`. If present, `ownerType` must also be present.
   * @format uuid
   */
  ownerId?: string;
  /** If set to true, the response may contain the allowed list property */
  allowed?: boolean;
}

export interface GetDevicesParams {
  /**
   * Determines whether the response should include data from MFU locations. Note that locations owned by MFU properties who are on the allow list will not be filtered out, regardless of the value of this param.
   * @default false
   */
  includeMfuLocations?: boolean;
  /**
   * If true will return hidden devices, else they will be filtered out.
   * @default false
   */
  includeHidden?: boolean;
  /**
   * The device capabilities to filter the results by.
   * The capabilities are treated as an "and" so all capabilities must be present.
   */
  capability?: string[];
  /** The device locations to filter the results by. */
  locationId?: string[];
  /** The device ids to filter the results by. */
  deviceId?: string[];
  /**
   * Include the status of the device's capabilities where permission is adequate to view them.
   * This requires `r:devices` permission.
   */
  includeStatus?: boolean;
  /** Include the Health status of the device. This requires `r:devices` permission. */
  includeHealth?: boolean;
  /** The device types to filter the results by. */
  type?: string[];
  /** The device categories to filter the results by. */
  category?: string[];
  /**
   * Treat all capability filter query params as a logical "or" or "and" with a default of "and".
   * @default "and"
   */
  capabilitiesMode?: 'or' | 'and';
  /**
   * Restricted devices are hidden by default. This query parameter will reveal them. Device status will
   * not be provided if the token does not have sufficient access level to view the device status even
   * if includeStatus parameter is set to true.
   */
  includeRestricted?: boolean;
  /** Only list devices accessible by the given accessLevel. */
  accessLevel?: number;
  /**
   * User-level devices are devices that are not tied to a location, but are instead tied to the user. In order
   * to include these devices in the list, a flag is needed to differentiate from devices listed by location.
   */
  includeUserDevices?: boolean;
  /**
   * GROUP type devices are devices that represent Device Groups. In order to include these devices in the list,
   * a flag needs to be included.
   */
  includeGroups?: boolean;
  /** Use this in conjunction with includeUserDevices to get only User-level devices. */
  excludeLocationDevices?: boolean;
  /** Include the actions permitted by this token's access for each individual resource. */
  includeAllowedActions?: boolean;
}

export interface GetDeviceParams {
  /**
   * Determines whether the response should include data from MFU locations. Note that locations owned by MFU properties who are on the allow list will not be filtered out, regardless of the value of this param.
   * @default false
   */
  includeMfuLocations?: boolean;
  /**
   * Include the status of the device's capabilities where permission is adequate to view them.
   * This requires `r:devices` permission.
   */
  includeStatus?: boolean;
  /** Expand the child device details nested in the device's description. */
  includeChildren?: boolean;
  /** Include the actions permitted by this token's access for each individual resource. */
  includeAllowedActions?: boolean;
  /** Include the Health status of the device. This requires `r:devices` permission. */
  includeHealth?: boolean;
  /** The Device ID */
  deviceId: string;
}

export interface UpdateDeviceParams {
  /** Include the actions permitted by this token's access for each individual resource. */
  includeAllowedActions?: boolean;
  /** The Device ID */
  deviceId: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = 'https://client.smartthings.com';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await (responseFormat !== 'json'
          ? response[responseFormat]()
          : response.text().then((text) => {
              try {
                return JSON.parse(text);
              } catch (e) {
                return text;
              }
            })
        )
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Client API
 * @version 5.0
 * @baseUrl https://client.smartthings.com
 *
 * API endpoints for mobile clients
 */
export class ClientV5Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  locations = {
    /**
     * @description List all Locations currently available in a user account.
     *
     * @tags Locations
     * @name ListLocations
     * @summary List Locations.
     * @request GET:/locations
     * @secure
     */
    listLocations: (query: ListLocationsParams, params: RequestParams = {}) =>
      this.request<PagedPublicLocations, ErrorResponse>({
        path: `/locations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Find a location by it's id.
     *
     * @tags Locations
     * @name GetLocation
     * @summary Find a location.
     * @request GET:/locations/{locationId}
     * @secure
     */
    getLocation: ({ locationId, ...query }: GetLocationParams, params: RequestParams = {}) =>
      this.request<PagedPublicLocation, ErrorResponse>({
        path: `/locations/${locationId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description List users for a location.
     *
     * @tags Locations, Users
     * @name GetLocationUsers
     * @summary List users for a location.
     * @request GET:/locations/{locationId}/users
     * @secure
     */
    getLocationUsers: ({ locationId, ...query }: GetLocationUsersParams, params: RequestParams = {}) =>
      this.request<LocationUsersResponse, any>({
        path: `/locations/${locationId}/users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a list of all users for all locations this user is a member of.
     *
     * @tags Locations, Users
     * @name GetAllLocationUsers
     * @summary Get all users for all locations a user owns.
     * @request GET:/locations/users
     * @secure
     */
    getAllLocationUsers: (query: GetAllLocationUsersParams, params: RequestParams = {}) =>
      this.request<LocationUsersResponse[], ErrorResponse>({
        path: `/locations/users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the Modes of all locations from a user's account.
     *
     * @tags Locations, Modes
     * @name GetAllModes
     * @summary Get the Modes of all locations.
     * @request GET:/locations/modes
     * @secure
     */
    getAllModes: (query: GetAllModesParams, params: RequestParams = {}) =>
      this.request<Modes[], ErrorResponse>({
        path: `/locations/modes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a list of all current modes.
     *
     * @tags Locations, Modes
     * @name GetAllCurrentModes
     * @summary Get a list of all current Location Modes.
     * @request GET:/locations/modes/current
     * @secure
     */
    getAllCurrentModes: (query: GetAllCurrentModesParams, params: RequestParams = {}) =>
      this.request<ModeWithLocationId[], ErrorResponse>({
        path: `/locations/modes/current`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the user's access for a given location. The caller must be the owner of the location.
     *
     * @tags Locations, Users
     * @name UpdateLocationUserAccess
     * @summary Update User's Access.
     * @request PUT:/locations/{locationId}/users/{userId}/access
     * @secure
     */
    updateLocationUserAccess: (
      locationId: string,
      userId: string,
      accessChangeRequest: LocationUserAccessChangeRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/locations/${locationId}/users/${userId}/access`,
        method: 'PUT',
        body: accessChangeRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description List all Rooms currently available in all locations for a user.
     *
     * @tags Locations, Rooms
     * @name ListAllRooms
     * @summary List Rooms
     * @request GET:/locations/rooms
     * @secure
     */
    listAllRooms: (params: RequestParams = {}) =>
      this.request<PagedRooms, ErrorResponse>({
        path: `/locations/rooms`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  geoplaces = {
    /**
     * @description List all Linked Places currently available across all locations for the user, or provide ownerType and ownerId to list Linked Places relative to a given owner (i.e. Linked Places for a specific location).
     *
     * @tags Geoplace
     * @name ListGeoplaces
     * @summary List Linked Places
     * @request GET:/geoplaces
     * @secure
     */
    listGeoplaces: (query: ListGeoplacesParams, params: RequestParams = {}) =>
      this.request<Geoplaces, ErrorResponse>({
        path: `/geoplaces`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  devices = {
    /**
     * @description Get a list of devices.
     *
     * @tags Devices
     * @name GetDevices
     * @summary List devices.
     * @request GET:/devices
     * @secure
     */
    getDevices: (query: GetDevicesParams, params: RequestParams = {}) =>
      this.request<PagedDevices, ErrorResponse>({
        path: `/devices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a device's description.
     *
     * @tags Devices
     * @name GetDevice
     * @summary Get a device's description.
     * @request GET:/devices/{deviceId}
     * @secure
     */
    getDevice: ({ deviceId, ...query }: GetDeviceParams, params: RequestParams = {}) =>
      this.request<Device, ErrorResponse>({
        path: `/devices/${deviceId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the properties of a Device. If the OAuth token used for this call is for a SmartApp that created the Device you are attempting to update, the call implicitly has permission for this API.
     *
     * @tags Devices
     * @name UpdateDevice
     * @summary Update a Device
     * @request PUT:/devices/{deviceId}
     * @secure
     */
    updateDevice: (
      { deviceId, ...query }: UpdateDeviceParams,
      updateDeviceRequest: UpdateDeviceRequest,
      params: RequestParams = {},
    ) =>
      this.request<Device, ErrorResponse>({
        path: `/devices/${deviceId}`,
        method: 'PUT',
        query: query,
        body: updateDeviceRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
}
